import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function getUser(UserName, Portal) {
  let queryString = "";
  if (UserName !== "") {
    queryString =
      "UserName=" + encodeURIComponent(UserName) + "&Portal=" + Portal;
  }
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
  };
  const response = await fetch(
    config.REG_API_BASE_URL + "/User?" + queryString,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
}
